import axios from "./axios";
export default {
  login: function (user, pw, captcha) {
    return axios.post("/api/auth/login", {
      account: user,
      password: pw,
      captcha
    });
  },
  islogin: function () {
    return axios.post("/api/user/info");;
  },
  loginOut: function () {
    window.localStorage.removeItem("vuex");
    return axios.get("/api/auth/logout");
  },
  userInfo() {
    return axios.post("/api/user/info");
  },
  validateMail(email_address, captcha,scene =  "验证邮箱") {
    return axios.post("/api/verify/email/send_code", {
      email_address,
      scene,
      captcha
    });
  },
  register(email_code, account, password, qq, area_code, phone, sms_code,email, server, upload, captcha) {
    // upload为文件列表
    let formData = new FormData();
    formData.append("data", JSON.stringify({
      email_code,
      account,
      password,
      qq:parseInt(qq,10),
      area_code,
      phone:parseInt(phone,10),
      email,
      server,
      sms_code,
      captcha
    }));
    if (upload) {
      for (let i = 0; i < upload.length; i++) {
        formData.append("upload[]", upload[i]);
      }
    }
    return axios.post("/api/auth/register", formData);
  },

  mail(email, email_code) {
    return axios.post("/api/user/modify/email", {
      email,
      email_code
    });
  },
  server(server, captcha,upload) {
    let formData = new FormData();
    formData.append("data", JSON.stringify({
      server,
      captcha
    }));
    if (upload) {
      for (let i = 0; i < upload.length; i++) {
        formData.append("upload[]", upload[i]);
      }
    }
    return axios.post("/api/user/modify/server", formData);
  },
  public(type) {
    return axios.post("/api/black/edit", {
      type: type
    });
  },
  resetPasswd(email,email_code,password,captcha){
    return axios.post("/api/auth/password/reset",{
      email,
      email_code,
      password,
      captcha
    })
  },
  registerSMS(area_code,phone,captcha){
    return axios.post("/api/verify/sms/send",{
      area_code,
      phone,
      scene: "验证手机号",
      captcha
    })
  }
};